import { SUBJECTS_SLUGS_TYPE } from 'platform-components';

import { useCalendarPlanQuery } from './queries';

export interface CalendarPlanQuery {
    subject: SUBJECTS_SLUGS_TYPE;
    grade: number | null;
    enabled?: boolean;
}

export function useCalendarPlanThemes(props: CalendarPlanQuery) {
    const { subject, grade, enabled } = props;
    return useCalendarPlanQuery(subject, grade, enabled);
}
